import {
  Box,
  InputBase,
  InputBaseProps as MuiInputBaseProps,
  Stack,
  Typography
} from '@mui/material';
import React from 'react';
import { Label } from './label';

export type InputProps = Omit<MuiInputBaseProps, 'error' | 'label'> & {
  readonly helperText?: string;
  readonly error?: string;
  readonly label?: string;
  readonly textVariant?: string;
};

export function Input({ textVariant = 'bodyS', ...props }: InputProps) {
  const { label, error, ...rest } = props;
  const value = rest.value as any;

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '100%',
        overflow: 'visible',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <InputLabel
        label={label}
        maxLength={
          props.inputProps?.maxLength
            ? props.inputProps.maxLength - value?.toString().length
            : undefined
        }
      />
      <Stack spacing={3} whiteSpace="normal">
        <InputBase fullWidth {...rest} error={error != null} sx={{ typography: textVariant }} />

        <HelpText helperText={props.helperText} />
        <Error error={error} />
      </Stack>
    </Box>
  );
}

function HelpText(props: Pick<InputProps, 'helperText'>) {
  if (props.helperText == null) return;

  return (
    <Typography
      variant="labelXSmall"
      sx={{ color: theme => theme.brandPalette.foreground.placeholder }}
    >
      {props.helperText}
    </Typography>
  );
}

function InputLabel(props: Pick<InputProps, 'label'> & { maxLength?: number }) {
  if (props.label == null) return;

  return (
    <Stack direction="row" justifyContent="space-between">
      <Label text={props.label} />
      {props.maxLength != null && (
        <Typography
          variant="subheadingXSmall"
          sx={{ color: theme => theme.brandPalette.foreground.placeholder }}
        >
          {props.maxLength}
        </Typography>
      )}
    </Stack>
  );
}

function Error({ error }: Pick<InputProps, 'error'>) {
  if (!error) return;

  return (
    <Typography
      variant="labelXSmall"
      component="p"
      sx={{
        color: theme => theme.brandPalette.foreground.negativeOffset,
        mt: 2,
        maxWidth: '100%',
        whiteSpace: 'normal'
      }}
    >
      {error}
    </Typography>
  );
}
